module.exports = __webpack_public_path__ + "img/icon4.2fa0f4ed.png";